import { render, staticRenderFns } from "./CheckControl.vue?vue&type=template&id=1c39320b&scoped=true&"
import script from "./CheckControl.vue?vue&type=script&lang=js&"
export * from "./CheckControl.vue?vue&type=script&lang=js&"
import style0 from "./CheckControl.vue?vue&type=style&index=0&id=1c39320b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39320b",
  null
  
)

export default component.exports